(function () {
  const MOBILE = '(max-width: 767.98px)';
  const MIN_ITEMS = 3;
  const SECONDS_PER_ITEM = 2.5;

  const mq = window.matchMedia(MOBILE);

  function enable(inner) {
    if (inner.dataset.marqueeReady === 'true') return;

    const track = inner.querySelector('.brand-logos__items');
    if (!track) return;

    const originals = Array.from(track.children);
    if (originals.length < MIN_ITEMS) return;

    originals.forEach(function (item) {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.marqueeClone = 'true';
      clone.querySelectorAll('a').forEach(function (link) {
        link.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
    });

    inner.style.setProperty('--marquee-duration', originals.length * SECONDS_PER_ITEM + 's');
    inner.classList.add('brand-marquee');
    inner.dataset.marqueeReady = 'true';
  }

  function disable(inner) {
    if (inner.dataset.marqueeReady !== 'true') return;

    inner.querySelectorAll('[data-marquee-clone]').forEach(function (clone) {
      clone.remove();
    });

    inner.classList.remove('brand-marquee');
    inner.style.removeProperty('--marquee-duration');
    delete inner.dataset.marqueeReady;
  }

  function apply(root) {
    const scope = root || document;
    scope.querySelectorAll('.brand-logos .brand-logos__inner').forEach(function (inner) {
      if (mq.matches) {
        enable(inner);
      } else {
        disable(inner);
      }
    });
  }

  function init() {
    apply();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', function () {
        apply();
      });
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(function () {
        apply();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    apply(event.target);
  });
})();
